import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import imgError from 'assets/img/error.png';

function Error({err}) {
  const style = {
    textAlign: 'center',
    padding: '25px',
  }

  return (
    <div style={style}>
      <img src={imgError} />
      <p>{err}</p>
    </div>
  )
}


export default Error;